module.exports = __webpack_public_path__ + "img/登录背景.c6c9e8f8.png";